<template>
  <div>
    <el-scrollbar style="height: 70vh">
      <el-form
        ref="womanform"
        :model="womanform"
        label-width="100px"
        style="padding-top: 10px"
        :rules="rules"
      >
        <el-form-item label="手机号码" prop="username">
          <el-input v-model="womanform.username" :maxlength="11" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="womanform.password" />
        </el-form-item>
        <el-form-item label="旧版本用户">
          <el-switch v-model="womanform.isSystem" />
        </el-form-item>
        <el-form-item label="高德地图坐标">
          <div class="flex">
            <label for="">{{ center.toString() }}</label>
            <el-amap-search-box
              class="search-box"
              :search-option="searchOption"
              :on-search-result="onSearchResult"
            />
          </div>
          <div :style="{ width: '100%', height: '300px' }">
            <el-amap
              :vid="'amap-vue2'"
              :zoom="zoom"
              :center="center"
              :events="events"
            >
              <el-amap-marker
                :position="marker.position"
                :events="marker.events"
                :visible="marker.visible"
                :draggable="marker.draggable"
              />
            </el-amap>
          </div>
        </el-form-item>
        <el-form-item label="平台" prop="platform">
          <el-radio-group v-model="womanform.platform">
            <el-radio
              v-for="(item, index) in platformOption"
              :key="index"
              :label="item.value"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="真人认证">
          <el-switch v-model="womanform.isAuthVideo" />
        </el-form-item>
        <el-form-item label="一键隐藏">
          <el-switch
            v-model="isHideAll"
            active-text="已隐藏"
            inactive-text="开放中"
          />
        </el-form-item>
        <el-form-item label="活跃标签时间" prop="briskDate">
          <el-date-picker
            v-model="womanform.briskDate"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="社交账号">
          <el-form-item label="微信号1">
            <el-input v-model="womanform.account.wechat1" />
          </el-form-item>
          <el-form-item label="微信号2">
            <el-input v-model="womanform.account.wechat2" />
          </el-form-item>
          <el-form-item label="微信号3">
            <el-input v-model="womanform.account.wechat3" />
          </el-form-item>
          <el-form-item label="QQ1">
            <el-input v-model="womanform.account.QQ1" />
          </el-form-item>
          <el-form-item label="QQ2">
            <el-input v-model="womanform.account.QQ2" />
          </el-form-item>
          <el-form-item label="QQ3">
            <el-input v-model="womanform.account.QQ3" />
          </el-form-item>
          <el-form-item label="手机号1">
            <el-input v-model="womanform.account.phone1" />
          </el-form-item>
          <el-form-item label="手机号2">
            <el-input v-model="womanform.account.phone2" />
          </el-form-item>
        </el-form-item>
        <el-form-item label="礼物门槛" prop="thresholdGiftId">
          <!-- <el-radio-group v-model="gift">
            <el-radio-button  v-for="(item, index) in giftsOptions" :key="index" :label="item.name+'(￥'+item.price+')'" />
          </el-radio-group> -->
          <el-radio-group v-model="womanform.thresholdGiftId">
            <el-radio v-for="(item, index) in giftsOptions" :key="index" border :label="item.id">{{ item.name+'(￥'+item.price+')' }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="womanform.nickname" />
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker
            v-model="womanform.birthday"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="头像">
          <uploadPic
            ref="uploadPic"
            :imageurl="avator"
            :width="40"
            :round="true"
            @upLoadImage="upLoadImage"
          />
        </el-form-item>
        <el-form-item label="找什么类型" prop="wantType">
          <el-radio-group v-model="womanform.wantType">
            <el-radio :label="'找soulmate'">找soulmate</el-radio>
            <el-radio :label="'找男朋友'">找男朋友</el-radio>
            <el-radio :label="'找玩伴'">找玩伴</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="约玩城市">
          <el-form-item>
            <el-cascader
              v-model="playCitys.city1"
              :options="areaOptions"
              :props="props"
              style="margin-bottom: 10px"
            />
          </el-form-item>
          <el-form-item>
            <el-cascader
              v-model="playCitys.city2"
              :options="areaOptions"
              :props="props"
              style="margin-bottom: 10px"
            />
          </el-form-item>
          <el-form-item>
            <el-cascader
              v-model="playCitys.city3"
              :options="areaOptions"
              :props="props"
              style="margin-bottom: 10px"
            />
          </el-form-item>
        </el-form-item>
        <el-form-item label="职业" prop="jobs">
          <el-select v-model="womanform.jobs" placeholder="请选择">
            <el-option
              v-for="(item, index) in girlJobs"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="个性签名" prop="signature">
          <el-input
            v-model="womanform.signature"
            :rows="2"
            type="textarea"
            style="width: 200px"
          />
          <span style="margin-left:10px">快速填充:</span>
          <el-tag type="info" @click="addInput('仅同城')">仅同城</el-tag>
          <el-tag type="info" @click="addInput('有空')">有空</el-tag>
        </el-form-item>
        <el-form-item label="女性形容词" prop="myAdjs">
          <el-checkbox-group v-model="womanform.myAdjs" size="mini">
            <el-checkbox-button
              v-for="(item, index) in girlAdjs"
              :key="index"
              :label="item"
            >{{ item }}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="身高" prop="stature">
          <el-input v-model="womanform.stature" />
          <span>CM 纯数字 140~230</span>
        </el-form-item>
        <el-form-item label="体重" prop="weight">
          <el-input v-model="womanform.weight" />
          <span>KG 纯数字 30~120</span>
        </el-form-item>
        <el-form-item label="罩杯" prop="cup">
          <el-input v-model="womanform.cup" style="width: 100px" />
          <span>数字+字母 30A 30B 30C ... 40g</span>
        </el-form-item>
        <el-form-item label="腰围" prop="waistline">
          <el-input v-model="womanform.waistline" />
          <span>KG 纯数字 50~200</span>
        </el-form-item>
        <el-form-item label="收到的标签" prop="receivedTabs">
          <el-checkbox-group v-model="womanform.receivedTabs" size="mini">
            <el-checkbox-button
              v-for="(item, index) in girlreceivedTabsoptions"
              :key="index"
              :label="item"
            >{{ item }}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <el-popconfirm title="确定添加？" @onConfirm="upload">
        <el-button
          slot="reference"
          :loading="button_loading"
          size="mini"
          type="primary" class="edit-button"
        >提交</el-button>
      </el-popconfirm>
    </el-scrollbar>
  </div>
</template>
<script>
import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
const areaoptions = require('@/utils/regions.json') // 引入省市数据
import md5 from 'js-md5' // 引入Md5加密
export default {
  components: { uploadPic },
  data() {
    return {
      womanform: {
        account: {
          QQ1: '',
          QQ2: '',
          QQ3: '',
          wechat1: '',
          wechat2: '',
          wechat3: '',
          phone1: '',
          phone2: ''
        },
        briskDate: '',
        receivedTabs: [],
        myAdjs: [],
        isSystem: true,
        isAuthVideo: true,
        isRich: false,
        platform: 0,
        wantType: '找soulmate',
        thresholdGiftId: '',
        jobs: '',
        signature: '',
        stature: '',
        weight: '',
        cup: '',
        waistline: ''
      }, // 用户基础信息
      isHideAll: true,
      zoom: 14, // 地图大小
      center: [113.264499, 23.130061], // 地图中心点
      marker: {
        // marker点
        position: [113.264499, 23.130061],
        visible: true,
        draggable: false
      },
      events: {
        // 地图点击事件
        click: (e) => {
          this.marker.position = [e.lnglat.lng, e.lnglat.lat]
          this.center = [e.lnglat.lng, e.lnglat.lat]
        }
      },
      searchOption: {
        // city: '上海',
        citylimit: false
      },
      dialogVisible: false,
      girlJobs: [], // 女性职业
      girlreceivedTabsoptions: [], // 男性个人标签
      platformOption: [
        // 登录平台
        {
          label: '安卓',
          value: 0
        },
        {
          label: 'iOS',
          value: 1
        }
      ],
      carsOptions: [], // 汽车品牌
      // 约玩城市
      playCitys: {
        city1: '',
        city2: '',
        city3: ''
      },
      areaOptions: areaoptions, // 省市数据
      props: {
        // 级联选择器规则
        value: 'name',
        label: 'name',
        children: 'childs',
        emitPath: false
      },
      // 校验规则
      rules: {
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入11位数字', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        platform: [
          { required: true, message: '请选择登陆平台', trigger: 'change' }
        ],
        briskDate: [{ required: true, message: '请选择日期', trigger: 'blur' }],

        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        birthday: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        wantType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        jobs: [{ required: true, message: '请选择职业', trigger: 'change' }],
        signature: [
          { required: true, message: '请输入个性签名', trigger: 'blur' }
        ],
        stature: [{ required: true, message: '请输入身高', trigger: 'blur' }],
        weight: [{ required: true, message: '请输入体重', trigger: 'blur' }],
        receivedTabs: [
          { required: true, message: '请输选择标签', trigger: 'blur' }
        ],
        thresholdGiftId: [
          { required: true, message: '请选择礼物门槛', trigger: 'change' }
        ],
        cup: [{ required: true, message: '请输入罩杯', trigger: 'blur' }],
        waistline: [{ required: true, message: '请输入腰围', trigger: 'blur' }]
      },
      button_loading: false,
      avator: '',
      girlAdjs: [], // 女性形容词
      giftsOptions: [], // 礼物
      gift: ''
    }
  },
  mounted() {
    const date = new Date()
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate() + 3
    d = d < 10 ? '0' + d : d
    const time = y + '-' + m + '-' + d
    this.womanform.briskDate = time
    this.womanform.stature = Math.round(Math.random() * (170 - 158)) + 158
    this.womanform.weight = Math.round(Math.random() * (60 - 46)) + 46
    var result = ["34C","34D","34E","36A","36B","36C","36D","36E"]
    var result = result[Math.floor(Math.random()*result.length)];
    // 生成一个0到6的数字
   		// var ranNum = Math.ceil(Math.random() * 6)
    // 大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~6;
    // 然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
    // 	result.push(String.fromCharCode(65 + ranNum))
    // var str = result.join('')
    // var num = Math.round(Math.random() * (40 - 30)) + 30
    // this.womanform.cup = num + str
    this.womanform.cup=result
    this.womanform.waistline = Math.round(Math.random() * (60 - 50)) + 50
    this.getConfig()
    this.getgiftList()
  },
  methods: {
    // 获取全局配置
    getConfig() {
      this.$api.global
        .getGlobalParams()
        .then((res) => {
          // var _jobs = res.boyJobs.concat(res.girlJobs)
          // this.jobs = Array.from(new Set(_jobs))
          this.girlJobs = res.girlJobs
          this.girlAdjs = res.girlAdjs
          this.womanform.jobs = res.girlJobs[0]
          this.girlreceivedTabsoptions = res.commentGirlTabs
          this.womanform.receivedTabs.push(res.commentGirlTabs[0], res.commentGirlTabs[1])
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 获取礼物信息
    getgiftList() {
      this.$api.global
        .getLimitGiftInfos()
        .then((res) => {
          // console.log(res)
          this.giftsOptions = res
          this.gift = res[0].name + '(￥' + res[0].price + ')'
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 上传图片回调函数
    upLoadImage(e) {
      console.log(e)
      this.avator = e
    },
    // 新增快速填充选项，点击把内容填入个性签名
    addInput(word) {
      this.womanform.signature = this.womanform.signature + word
    },
    // 保存用户信息
    upload() {
      this.$refs.womanform.validate((valid) => {
        if (valid) {
          this.button_loading = true
          // console.log(111)
          var _memberInfo = JSON.parse(JSON.stringify(this.womanform))
          _memberInfo.password = md5(_memberInfo.password)
          _memberInfo.avator = this.avator
          _memberInfo.isHideAll = this.isHideAll
          _memberInfo.birthday = this.$moment(_memberInfo.birthday).format(
            'YYYY-MM-DD'
          )
          _memberInfo.briskDate = this.$moment(_memberInfo.briskDate).format(
            'YYYY-MM-DD'
          )
          _memberInfo.vipValidDate = this.$moment(
            _memberInfo.vipValidDate
          ).format('YYYY-MM-DD')
          _memberInfo.receivedTabs = _memberInfo.receivedTabs.toString()
          _memberInfo.myAdjs = _memberInfo.myAdjs.toString()
          _memberInfo.playCitys = []
          for (const key in this.playCitys) {
            if (this.playCitys[key] !== '') {
              _memberInfo.playCitys.push(this.playCitys[key])
            }
          }
          _memberInfo.account = JSON.stringify(_memberInfo.account)
          _memberInfo.playCitys = _memberInfo.playCitys.toString()
          _memberInfo.lon = this.center[0]
          _memberInfo.lat = this.center[1]
          //   console.log(_memberInfo);
          this.$api.global
            .addWomanMember(_memberInfo)
            .then((res) => {
              this.$message.success(res)
              this.$emit('close')
            })
            .catch((err) => {
              this.$message.error(err || '服务器错误，请稍后重试')
            })
            .finally(() => {
              this.button_loading = false
            })
        }
      })
    },
    // 地图搜索
    onSearchResult(pois) {
      console.log(pois)

      if (pois.length > 0) {
        // this.playCitys.city1=pois[0].name
        this.center = [pois[0].lng, pois[0].lat]
        AMap.plugin('AMap.CitySearch', () => {
          var citySearch = new AMap.CitySearch()
          citySearch.getLocalCity((status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              // 查询成功，result即为当前所在城市信息
              console.log('通过ip获取当前城市：', result)

              // 逆向地理编码
              AMap.plugin('AMap.Geocoder', () => {
                var geocoder = new AMap.Geocoder({
                  // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                  city: result.adcode
                })
                var arr = []
                arr.push(pois[0].location.lng, pois[0].location.lat)

                geocoder.getAddress(arr, (status, data) => {
                  if (status === 'complete' && data.info === 'OK') {
                    // result为对应的地理位置详细信息
                    console.log(data)
                    this.playCitys.city1 = data.regeocode.addressComponent.city || data.regeocode.addressComponent.province
                  }
                })
              })
            }
          })
        })
        // pois.forEach((poi) => {
        //   let { lng, lat } = poi;
        //   lngSum += lng;
        //   latSum += lat;
        //   // this.markers.push([poi.lng, poi.lat]);
        // });
      }
      // let _center = {
      //   lng: lngSum / pois.length,
      //   lat: latSum / pois.length,
      // };
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form::v-deep {
  .el-cascader {
    .el-input {
      width: 100% !important;
    }
  }
  .el-input {
    width: 50%;
    margin-right: 10px;
  }
  .el-tag{
    padding: 0 10px;
    margin: 0 5px;
  }
  .el-checkbox-button {
    // background-color: red;
    margin: 0 10px 10px 0;
    .el-checkbox-button__inner {
      border: 1px solid #dcdfe6;
      border-radius: 20px;
      // border-left: 1px!important;
      // background-color: red;
    }
  }
}
.flex{
      justify-content: space-between;
      padding-right: 6px;
      margin-bottom: 10px;
  .el-vue-search-box-container{
    // width: 200px;
    border: 1px solid #666666;
    border-radius: 10px;
    height:36px;
    padding: 0 10px;
    // margin-left: -10px;
  }
}
.el-radio-button{
    margin: 0 5px;
    border-left: 1px solid #DCDFE6;
    border-radius: 0;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner{
  border-left:0
}
 .el-radio-button:first-child .el-radio-button__inner {
    // border-left: 1px solid #DCDFE6;
    border-radius: 0;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}
.el-radio-button:last-child .el-radio-button__inner{
      border-radius: 0;
}
.el-tag.el-tag--info {
    cursor: pointer;
}
.el-radio--mini.is-bordered{
  margin-right: 0;
}
</style>
